import React from 'react';

const People = () => {
  return (
    <div>
      
    </div>
  );
}

export default People;
